import groq from "groq"

export const articleMainGroupProjection = () => groq`
    "id": _id,
    key,
    name
`
